import React, { useState, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { change } from 'redux-form';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import { showNotificationAutoDestroy } from '../../../shared/components/ShowNotification';
import {
  changeLoadingTrue,
  changeLoadingFalse,
} from '../../../redux/actions/loadingActions';

import GraphQL from '../../../GraphQL';
import SmartCard from '../../../shared/components/SmartCard';
import ModalChangePassword from './ModalChangePassword';
import EmployeeForm from './Form';
import {
  changePassEmployeeMutation,
  employeeListByFilter,
  relationAccessProfileEmployeeListByEmployeeId,
  relationCommunicationChannelEmployeeListByEmployeeId,
  relationSubjectEmployeeListByEmployeeId,
  saveEmployeeMutation,
} from '../../../shared/queries/Employee';
import changeSchoolTermList from '../../../redux/actions/schoolTermActions';
import { schoolTermEmployeeRelationshipListByEmployeeIdQuery } from '../../../shared/queries/SchoolTermEmployeeRelation';
import { relationEmployeeClassListByTermsQuery } from '../../../shared/queries/RelationEmployeeClass';

const EmployeeFormHandler = ({ match, t, history, dispatch }) => {
  const [dto, setDto] = useState({ active: true, id: 0 });
  const [formOn, setFormOn] = useState(false);
  const [schoolTerm, setschoolTerm] = useState([]);
  const [accessProfile, setAccessProfile] = useState([]);
  const [modalChangePassword, setModalChangePassword] = useState(false);
  const [schoolClass, setSchoolClass] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [communicationChannels, setCommunicationChannels] = useState([]);
  const [showCommunicationChannel, setShowCommunicationChannel] =
    useState(false);
  const [selectedSchoolTerm, setSelectedSchoolTerm] = useState([]);

  const handleBack = () => {
    history.push('/minime/funcionario');
  };

  const showLoading = () => {
    dispatch(changeLoadingTrue());
  };

  const hideLoading = () => {
    dispatch(changeLoadingFalse());
  };

  const updateSchoolTermList = (list) => {
    dispatch(changeSchoolTermList(list));
  };

  const toggleModalChangePassword = () => {
    setModalChangePassword(!modalChangePassword);
  };

  const changeTermFormField = (value) => {
    dispatch(change('EmployeeForm', 'terms', value));
  };

  const getSelectedSchoolTermsEmployee = (schoolTermList) => {
    const employeeSchoolTerm = schoolTermList.filter((item) => item.id);
    changeTermFormField(employeeSchoolTerm);
    return employeeSchoolTerm;
  };

  const changeSchoolClassFormField = (value) => {
    dispatch(change('EmployeeForm', 'classes', value));
  };

  const selectedSchoolClassEmployee = (schoolClassList) => {
    const employeeSchoolClass = schoolClassList.filter((item) => item.id);
    changeSchoolClassFormField(employeeSchoolClass);
  };

  const changeSubjectsFormField = (value) => {
    dispatch(change('EmployeeForm', 'subjects', value));
  };

  const selectedSubjectsEmployee = (subjectList) => {
    const employeeSubjects = subjectList.filter((item) => item.id);
    changeSubjectsFormField(employeeSubjects);
  };

  const changeAccessProfileFormField = (value) => {
    dispatch(change('EmployeeForm', 'profiles', value));
  };

  const getSelectedAccessProfileEmployee = (profileList) => {
    const employeeAccessProfile = profileList.filter((item) => item.id);
    changeAccessProfileFormField(employeeAccessProfile);
    return employeeAccessProfile;
  };

  const changeCommunicationChannelsFormField = (value) => {
    dispatch(change('EmployeeForm', 'channels', value));
  };

  const selectedCommunicationChannelsEmployee = (channelList) => {
    const employeeChannels = channelList.filter((item) => item.id);
    changeCommunicationChannelsFormField(employeeChannels);
  };

  const updatedChannelsFormField = (value) => {
    change('channels', value);
  };

  const onChangeProfile = (values) => {
    let accessCommunicationChannels = false;
    if (values) {
      accessCommunicationChannels = values.some(
        (item) => item.profile.accessToChat
      );
    } else {
      updatedChannelsFormField([]);
    }
    setShowCommunicationChannel(accessCommunicationChannels);
  };

  const onChangePass = (values) => {
    toggleModalChangePassword();
    showLoading();
    const mutation = changePassEmployeeMutation(dto.id, values);
    GraphQL(mutation, {})
      .then(() => {
        showNotificationAutoDestroy(
          'success',
          t('success.title'),
          t('success.successfully-saved')
        );
      })
      .catch(() => {
        showNotificationAutoDestroy(
          'danger',
          t('notifications.error'),
          t('errors.error-to-save')
        );
      })
      .finally(() => {
        hideLoading();
      });
  };

  const loadCommunicationChannelsByEmployeeId = (employeeId) => {
    showLoading();
    const query =
      relationCommunicationChannelEmployeeListByEmployeeId(employeeId);
    GraphQL(query, {})
      .then((res) => {
        const communicationChannelList =
          res.relationCommunicationChannelEmployeeListByEmployeeId;
        if (communicationChannelList) {
          const channels = communicationChannelList.map((item) => ({
            ...item,
            value: item.channel.id,
            label: item.channel.name,
          }));
          setCommunicationChannels(channels);
          selectedCommunicationChannelsEmployee(channels);
        }
      })
      .catch(() => {
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      })
      .finally(() => {
        hideLoading();
      });
  };

  const loadAccessProfileByEmployeeId = (employeeId) => {
    showLoading();
    const query = relationAccessProfileEmployeeListByEmployeeId(employeeId);
    GraphQL(query, {})
      .then((res) => {
        const accessProfileList =
          res.relationAccessProfileEmployeeListByEmployeeId;
        if (accessProfileList) {
          const access = accessProfileList.map((item) => ({
            ...item,
            value: item.profile.id,
            label: item.profile.name,
          }));
          setAccessProfile(access);
          const employeeAccessProfile =
            getSelectedAccessProfileEmployee(access);
          onChangeProfile(employeeAccessProfile);
        }
      })
      .catch(() => {
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      })
      .finally(() => {
        hideLoading();
      });
  };

  const loadSubjectsByEmployeeId = (employeeId) => {
    showLoading();
    const query = relationSubjectEmployeeListByEmployeeId(employeeId);
    GraphQL(query, {})
      .then((res) => {
        const subjectEmployeeList = res.relationSubjectEmployeeListByEmployeeId;
        if (subjectEmployeeList) {
          const subjectsList = subjectEmployeeList.map((item) => ({
            ...item,
            value: item.subject.id,
            label: item.subject.name,
          }));
          setSubjects(subjectsList);
          selectedSubjectsEmployee(subjectsList);
        }
      })
      .catch(() => {
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      })
      .finally(() => {
        hideLoading();
      });
  };

  const loadSchoolClassBySchoolTerm = (employeeId, selectedSchoolTerms) => {
    showLoading();
    const dataQuery = relationEmployeeClassListByTermsQuery(
      employeeId,
      selectedSchoolTerms
    );
    GraphQL(dataQuery, {})
      .then(({ relationEmployeeClassListByTerms }) => {
        if (relationEmployeeClassListByTerms) {
          const schoolClassList = relationEmployeeClassListByTerms.map(
            (item) => ({
              ...item,
              value: item.class.id,
              label: item.class.name,
            })
          );
          setSchoolClass(schoolClassList);
          selectedSchoolClassEmployee(schoolClassList);
        }
      })
      .catch(() => {
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      })
      .finally(() => {
        hideLoading();
      });
  };

  const loadSchoolTermByEmployeeId = (employeeId) => {
    showLoading();
    const query =
      schoolTermEmployeeRelationshipListByEmployeeIdQuery(employeeId);
    GraphQL(query, {})
      .then(({ schoolTermEmployeeRelationshipListByEmployeeId }) => {
        if (schoolTermEmployeeRelationshipListByEmployeeId) {
          const resultSchoolTerms =
            schoolTermEmployeeRelationshipListByEmployeeId.map((item) => ({
              ...item,
              value: item.schoolTerm.id,
              label: item.schoolTerm.name,
            }));
          setschoolTerm(resultSchoolTerms);

          const employeeSchoolTerm =
            getSelectedSchoolTermsEmployee(resultSchoolTerms);
          const reducedSchoolTerm = employeeSchoolTerm.reduce(
            (acc, item) => acc.concat(item.schoolTerm),
            []
          );
          setSelectedSchoolTerm(reducedSchoolTerm);
          loadSchoolClassBySchoolTerm(employeeId, reducedSchoolTerm);
        }
      })
      .catch(() => {
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      })
      .finally(() => {
        hideLoading();
      });
  };

  function findById(id) {
    showLoading();
    const filter = {
      id,
      usuarioChatInterno: false,
      ativo: true,
      filterByStatus: false,
      pedagogicAdm: false,
      updaterId: 0,
      usuarioChat: false,
      active: true,
    };
    const query = employeeListByFilter(filter);
    GraphQL(query, {})
      .then(async (res) => {
        const employeeList = res.employeeListByFilter;
        if (employeeList.length) {
          const employee = employeeList[0];
          setDto(employee);
          loadSchoolTermByEmployeeId(employee.id);
          loadSubjectsByEmployeeId(employee.id);
          loadAccessProfileByEmployeeId(employee.id);
          loadCommunicationChannelsByEmployeeId(employee.id);
        } else {
          showNotificationAutoDestroy(
            'danger',
            t('notifications.error'),
            t('notifications.record-not-found')
          );
          handleBack();
        }
      })
      .catch((error) => {
        if (error.response) {
          showNotificationAutoDestroy(
            'danger',
            t('errors.title'),
            t('errors.error-to-loading')
          );
        }
      })
      .finally(() => {
        hideLoading();
      });
  }

  const handleSubmit = (values) => {
    showLoading();
    const mutation = saveEmployeeMutation(values);
    GraphQL(mutation, {})
      .then(() => {
        handleBack();
        showNotificationAutoDestroy(
          'success',
          t('success.title'),
          t('success.successfully-saved')
        );
        const mappedTerms = values.terms.map((term) => ({
          ...term.schoolTerm,
        }));
        dispatch(updateSchoolTermList(mappedTerms));
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        hideLoading();
      });
  };

  const onChangeSchoolTerm = (values) => {
    let selected = [];
    if (values) {
      selected = values.map((item) => ({
        ...item.schoolTerm,
        filterByStatus: false,
        updaterId: 0,
      }));
      loadSchoolClassBySchoolTerm(dto.id, selected);
    } else {
      changeSchoolClassFormField([]);
    }
    setSelectedSchoolTerm(selected);
  };

  const loadData = async () => {
    loadAccessProfileByEmployeeId(0);
    loadSchoolTermByEmployeeId(0);
    loadSubjectsByEmployeeId(0);
    loadCommunicationChannelsByEmployeeId(0);
  };

  useEffect(() => {
    if (match.params.id && match.params.id > 0) {
      if (dto.id !== parseInt(match.params.id, 0)) {
        findById(Number(match.params.id));
      } else {
        setFormOn(true);
      }
    } else {
      loadData();
      setFormOn(true);
    }
  }, [dto]);

  return (
    <SmartCard title={t('panels.funcionario')}>
      <ModalChangePassword
        toggle={toggleModalChangePassword}
        isOpen={modalChangePassword}
        onSubmit={onChangePass}
      />
      {formOn && (
        <EmployeeForm
          onSubmit={handleSubmit}
          handleBack={handleBack}
          dto={dto}
          toggleChangePass={toggleModalChangePassword}
          schoolTerm={schoolTerm}
          accessProfile={accessProfile}
          schoolClass={schoolClass}
          subjects={subjects}
          communicationChannels={communicationChannels}
          showLoading={showLoading}
          hideLoading={hideLoading}
          showCommunicationChannel={showCommunicationChannel}
          onChangeProfile={onChangeProfile}
          selectedSchoolTerm={selectedSchoolTerm}
          onChangeSchoolTerm={onChangeSchoolTerm}
        />
      )}
    </SmartCard>
  );
};

EmployeeFormHandler.propTypes = {
  t: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
  match: ReactRouterPropTypes.match.isRequired,
};

export default withTranslation('common')(
  connect((state) => ({
    loading: state.loading,
  }))(EmployeeFormHandler)
);
